// Pixel tracks keep the same shelf layout while only nearby slabs own images.
export function wallTracks(total, columns, estimatedHeight, measured = new Map(), gap = 22) {
  const rows = Math.ceil(total / columns);
  const heights = Array.from({ length: rows }, (_, row) => measured.get(row) || estimatedHeight);
  const offsets = [0];
  for (const height of heights) offsets.push(offsets[offsets.length - 1] + height + gap);
  return { heights, offsets, total, columns };
}

export function wallRowAt(tracks, top) {
  let low = 0, high = tracks.heights.length;
  while (low < high) {
    const middle = (low + high) >>> 1;
    if (tracks.offsets[middle + 1] <= top) low = middle + 1;
    else high = middle;
  }
  return Math.min(low, Math.max(0, tracks.heights.length - 1));
}

export function wallWindow(tracks, top, viewportHeight, overscan = 2) {
  if (!tracks.total) return { start: 0, end: 0 };
  const first = Math.max(0, wallRowAt(tracks, top) - overscan);
  const last = Math.min(tracks.heights.length, wallRowAt(tracks, top + viewportHeight) + overscan + 1);
  return { start: first * tracks.columns, end: Math.min(tracks.total, last * tracks.columns) };
}
